import { api } from "@/lib/api";
import { logger } from "@/lib/logger";

// Clean, centralized analytics events (fire-and-forget)
export const track = (name, meta = {}) => {
  try {
    api.post("/analytics/event", { name, meta }).catch((err) => {
      logger.debug(`analytics: failed to send "${name}"`, err?.message);
    });
  } catch (err) {
    logger.debug(`analytics: track("${name}") threw`, err?.message);
  }
};

export const EVENTS = {
  LANDING_VIEW: "landing_page_visit",
  CTA_CLICK: "cta_click",
  PRICING_VIEW: "pricing_view",
  CHECKOUT_STARTED: "checkout_started",
  PLAN_SELECTED: "plan_selected",
  PAYMENT_SUCCESS: "payment_success",
  ONBOARDING_COMPLETED: "onboarding_completed",
  FIRST_MOCK_UPLOADED: "first_mock_uploaded",
  FIRST_DIAGNOSIS: "first_ai_diagnosis",
  FIRST_STUDY_PLAN: "first_study_plan",
  FIRST_PRACTICE: "first_practice_session",
};
